import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'
import DropzoneAvatar from '@/components/share/dropzone_avatar'
var Validator = require('validatorjs')
Validator.useLang('ja')

export default {
  name: 'settings',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar,
    DropzoneAvatar
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    env () {
      return this.$store.getters.env
    },
    avatar () {
      return this.$store.getters.avatar
    },
    api () {
      return this.$store.getters.api
    },
    avatarState () {
      return this.user.photoFlag === '1' && this.isAvatar
    },
    emailState () {
      let v = new Validator({
        'メールアドレス': this.email.value
      }, {
        'メールアドレス': 'required|email'
      })

      let pass = v.passes()
      this.email.error = v.errors.first('メールアドレス')

      return pass
    },
    passwordOldState () {
      let v = new Validator({
        '現在のパスワード': this.password.old
      }, {
        '現在のパスワード': 'required|min:8'
      })

      let pass = v.passes()
      this.password.oldError = v.errors.first('現在のパスワード')

      return !this.password.edit || pass
    },
    passwordState () {
      let v = new Validator({
        '新しいパスワード': this.password.value
      }, {
        '新しいパスワード': 'required|min:8'
      })

      let pass = v.passes()
      this.password.error = v.errors.first('新しいパスワード')

      return !this.password.edit || pass
    },
    passwordConfirmState () {
      let v = new Validator({
        '新しいパスワード（確認用）': this.password.confirm
      }, {
        '新しいパスワード（確認用）': 'required|min:8'
      })

      let pass = v.passes()
      this.password.confirmError = v.errors.first('新しいパスワード（確認用）')

      if (pass && this.password.value !== this.password.confirm) {
        pass = false
        this.password.confirmError = 'パスワードが一致しません'
      }

      return !this.password.edit || pass
    },
    hpState () {
      let v = new Validator({
        'Webサイト': this.company.hp
      }, {
        'Webサイト': 'required|url'
      })

      let pass = v.passes()
      this.error.hp = v.errors.first('Webサイト')

      return pass
    },
    ipoState () {
      return this.company.ipo === true || this.company.ipo === false
    },
    industryState () {
      return this.company.industry.length > 0
    },
    chargeState () {
      return this.charge.lastName && this.charge.firstName &&
             this.charge.lastNameYomi && this.charge.lastNameYomi &&
             this.charge.department &&
             this.charge.position &&
             this.charge.phone
    },
    presidentState () {
      return this.president.lastName && this.president.firstName &&
             this.president.lastNameYomi && this.president.lastNameYomi
    }
  },
  data () {
    return {
      alert: {
        dismissSecs: 2,
        dismissCountDown: 0,
        variant: ''
      },
      sidebar_tab: '4',
      loading: true,
      updating: false,
      isAvatar: false,
      isUpload: false,
      avatarId: '',
      email: {
        value: '',
        error: '',
        edit: false,
        updating: false,
        verify: false,
        verifyCode: '',
        firstError: '',
        secondError: ''
      },
      password: {
        old: '',
        value: '',
        confirm: '',
        oldError: '',
        error: '',
        confirmError: '',
        edit: false,
        updating: false,
        apiError: ''
      },
      company: {
        yomi: undefined,
        hp: '',
        phone: undefined,
        buildYear: undefined,
        capital: undefined,
        sales: undefined,
        employee: undefined,
        ipo: '',
        industry: []
      },
      error: {
        hp: '',
        ipo: '',
        industry: ''
      },
      salesOptions: [],
      employeeOptions: [],
      ipoOptions: [
        { value: true, text: 'はい、上場企業です' },
        { value: false, text: 'いいえ、上場企業ではありません' }
      ],
      industryOptions: [],
      industrySelect: '',
      industryDetails: {},
      charge: {},
      president: {}
    }
  },
  methods: {
    getDropzoneData (data) {
      this.isUpload = data.isUpload
      this.avatarId = data.avatarId
      this.$store.commit('onAvatarStateChanged', data.avatarId)
    },
    updateEmail () {
      this.email.updating = true

      if (!this.emailState || this.email.value === this.user.email) {
        this.email.updating = false
      } else {
        this.email.edit = false
        this.$cognito.updateAttributes('email', this.email.value)
          .then(() => {
            this.email.updating = false
            this.email.verify = true
          })
          .catch(err => {
            console.log(err)
            this.email.firstError = err.message
            this.email.updating = false
            this.email.edit = true
          })
      }
    },
    verifyCode () {
      this.email.updating = true

      if (this.email.verifyCode.length !== 6) {
        this.email.updating = false
      } else {
        this.email.verify = false
        this.$cognito.verifyAttribute(this.email.verifyCode)
          .then(() => {
            let additionalParams = {
              queryParams: {
                type: 'email'
              }
            }

            let body = {
              email: this.email.value
            }

            this.$apig.patch(this.api.ENTERPRISE, {}, additionalParams, body)
              .then(() => {
                this.$store.commit('onUserStateChanged', {
                  enterpriseId: this.user.enterpriseId,
                  email: this.email.value,
                  photoFlag: this.user.photoFlag
                })
                this.email.updating = false
              })
              .catch(err => {
                console.log(err)
                this.email.secondError = err.response.data.message
                this.email.updating = false
                this.email.verify = true
              })
          })
          .catch(err => {
            console.log(err)
            this.email.secondError = err.message
            this.email.updating = false
            this.email.verify = true
          })
      }
    },
    changePassword () {
      this.password.updating = true

      if (!this.passwordOldState || !this.passwordState || !this.passwordConfirmState) {
        this.password.updating = false
      } else {
        this.password.edit = false
        this.$cognito.changePassword(this.password.old, this.password.value)
          .then(() => {
            this.password.updating = false
          })
          .catch(err => {
            console.log(err)
            this.password.apiError = err.message
            this.password.updating = false
            this.password.edit = true
          })
      }
    },
    cancelEdit (key) {
      switch (key) {
        case 'email':
          this.email.value = this.user.email
          break
        case 'password':
          this.password.value = this.password.default
          break
      }

      this[key].edit = false
    },
    removeIndustry (item, key) {
      this.company.industry.splice(key, '1')
      this.industryDetails[item.industryId.split('-')[0]][item.industryId.split('-')[1]].selected = false
    },
    addIndustry (item, key) {
      this.company.industry.push({
        industryId: `${this.industrySelect}-${item.detail_cd}`,
        detail: item.detail
      })
      this.industryDetails[this.industrySelect][key].selected = true
    },
    update () {
      if (!this.hpState || !this.ipoState || !this.industryState || !this.chargeState || !this.presidentState) {
        this.alert.dismissCountDown = this.alert.dismissSecs
        this.alert.variant = 'danger'
        this.alert.message = '必須項目を入力してください'
      } else {
        this.updating = true
        let additionalParams = {
          queryParams: {
            type: 'company'
          }
        }

        let company = {}

        for (let key in this.company) {
          if (key !== 'address' && key !== 'zip_cd' && (this.company[key] || this.company[key] === false)) company[key] = this.company[key]
        }

        let body = {
          company,
          charge: this.charge,
          president: this.president
        }

        this.$apig.patch(this.api.ENTERPRISE, {}, additionalParams, body)
          .then(() => {
            this.alert.dismissCountDown = this.alert.dismissSecs
            this.alert.variant = 'success'
            this.alert.message = '企業情報を更新しました！'
            this.updating = false
          })
          .catch(err => {
            console.log(err)
            this.alert.dismissCountDown = this.alert.dismissSecs
            this.alert.variant = 'danger'
            this.alert.message = '一時的なエラーが発生しました。時間を置いてお試しください。'
            this.updating = false
          })
      }
    },
    countDownChanged (dismissCountDown) {
      this.alert.dismissCountDown = dismissCountDown
    }
  },
  mounted () {
    this.email.value = this.user.email
    this.isAvatar = this.user.photoFlag === '1'

    let additionalParams = {
      queryParams: {
        type: 'base'
      }
    }

    this.$apig.get(this.api.ENTERPRISE, {}, additionalParams, {})
      .then(response => {
        if (response.data.company) {
          for (let key in response.data.company) {
            this.company[key] = response.data.company[key]
          }
        }
        this.industryOptions = response.data.industryOptions
        this.industryDetails = response.data.industryDetails
        this.salesOptions = response.data.salesOptions
        this.employeeOptions = response.data.employeeOptions
        if (response.data.charge) this.charge = response.data.charge
        if (response.data.president) this.president = response.data.president

        this.loading = false
      })
      .catch(err => {
        console.log(err)
        this.loading = false
        // TODO エラーページへ遷移
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/base/base.js